import cx from "clsx";
import type { DealEstimationHistoryContext } from "~/models/DealEstimationHistory";
import Styles from "../list/ConstructionList.module.scss";
import { ConstructionListRow } from "./ConstructionListRow";

type Props = {
	companyType: "client" | "vendor" | "partner";
	constructionContext: DealEstimationHistoryContext;
};
export function ConstructionConfirmedList({
	constructionContext,
	companyType
}: Props) {
	return (
		<div>
			<table className={Styles.List}>
				<thead>
					<tr className={cx(Styles.ListRow, Styles.Header)}>
						<th className={Styles.OrderHandle} />
						<th className={Styles.EstimationType}>区分</th>
						<th className={Styles.Estimation}>施工項目</th>
						<th className={Styles.UnitAmount}>単価 * 数量</th>
						<th className={Styles.ChargePer}>負担割合</th>
						<th className={Styles.Amount}>価格</th>
					</tr>
				</thead>
				<tbody>
					<ConstructionListRow
						companyType={companyType}
						constructionContext={constructionContext}
					/>
				</tbody>
			</table>
		</div>
	);
}
